import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import inactivestatus from "../../assets/images/inactivestatus.svg";
import collobers from "../../assets/images/collobers.png";
import colloberstwo from "../../assets/images/colloberstwo.png";
import editpencilIcon from "../../assets/images/editpencilIcon.svg";
import deleteaction from "../../assets/images/deleteaction.svg";
import activestatus from "../../assets/images/activeStatus.svg";
import { useDispatch, useSelector } from "react-redux";
import { WorkFlowGetList } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import Nodata from "../../component/common-component/Nodata";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import { commonservices, TIMEZONE_LIST } from "../../services/CommonServices";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../DeleteModal";
import { API_URL } from "../../services/APIRoute";
import { WorkTeamGetTeamList } from "../../services/ReduxTookit/Slice/WorkflowTeamRedux";
import profileicon from "../../assets/images/dummy-profile-pic.jpg";

const WorkflowManagementModel = () => {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workflowList, setWorkflowList] = useState(null);
  const [DeletePayload, setDeletePayload] = useState({
    workflowid: "",
    status: "",
  });
  const [modalShow, setModalShow] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const getWorkFlowGetListData = useSelector(
    (item) => item?.workflowredux?.WorkFlowGetListData?.data
  );
  const getTimeZoneObj = (timezone) => {
    let filterdData = TIMEZONE_LIST?.filter((x) => x?.value === timezone);

    return filterdData;
  };

  const fetchData = async (id) => {
    let body = {
      subscriberid: parseInt(id),
    };
    try {
      dispatch(WorkTeamGetTeamList(body))?.then((res) => {
        if (res?.payload?.isValidate) {
          let filteredUContact = res?.payload?.data?.data.filter(
            (itm) => itm?.rolename && itm
          );
          setContactList(res?.payload?.data?.data);
        } else {
          setContactList([]);
        }
      });
    } catch (error) {
      // setIsWorkFlowIsRunning(false);
    }
    // }
  };

  const getContactListByWorkflow = (workFlowId) => {
    return contactList?.filter((itm) => itm.workflowid === workFlowId);
  };

  useEffect(() => {
    if (getWorkFlowGetListData && getWorkFlowGetListData?.isValidate) {
      setWorkflowList(getWorkFlowGetListData?.data?.data);
      setLoading(false);
    }
    if (getWorkFlowGetListData && !getWorkFlowGetListData?.isValidate) {
      setWorkflowList(null);
      setLoading(false);
    }
  }, [getWorkFlowGetListData]);

  function getWorkFlowList() {
    setLoading(true);
    dispatch(WorkFlowGetList({}));
  }

  useEffect(() => {
    if (Userdata) {
      fetchData(Userdata.subscriberid);
    }
    getWorkFlowList();
  }, []);

  return (
    <div className="setting-table-main">
      <div className="table-wrapper-main">
        <Table responsive>
          <thead>
            <tr>
              <th>Workflow Name</th>
              {/* <th className="">Active</th> */}
              <th className="text-center">Machine</th>
              <th className="text-center">Created On</th>
              <th className="text-center">next schedule</th>
              <th className="">Status</th>
              <th className="text-end">Collaborators</th>
              {/* <th className="text-end sticky-actions">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Loader type={LoaderType.TableRow} count={8} nooftd={6} />
            ) : (
              <>
                {workflowList?.length > 0 ? (
                  workflowList?.map((item) => {
                    const contacts = getContactListByWorkflow(item?.workflowid);
                    const displayedContacts = contacts?.slice(0, 5);
                    const remainingCount =
                      contacts.length - displayedContacts.length;
                    let timeZone = getTimeZoneObj(
                      item?.timezone ? item?.timezone : ""
                    );
                    return (
                      <tr key={item?.workflowid}>
                        <td
                          className="theme-color-text fw600 sticky-workflow cursor-pointer"
                          title={item?.workflowname}
                          onClick={() => {
                            let data = commonservices.bodyEncryption(
                              `${item?.workflowid}?v=1&r=wa`
                            );
                            navigate(`/flow-new/${data}`, {
                              state: {
                                isViewMode: false,
                                flowRoleRights: item,
                              },
                            });
                          }}
                        >
                          {commonservices.truncateText(item?.workflowname, 30)}
                        </td>
                        {/* <td>
                          {commonservices.getStatus(item?.argoworkflowstatus)}
                        </td> */}
                        <td className="text-center theme-color-text fw600">
                          {item?.totalmachine ? item?.totalmachine : 0}
                        </td>
                        <td className="text-center">
                          {item?.createdon
                            ? commonservices.getDateInFormat(item?.createdon)
                            : ""}
                        </td>
                        <td className="text-center ">
                          {item?.argoworkflowstatus === "Active" &&
                          item?.nextrunon
                            ? commonservices.convertTimeToLocal(item?.nextrunon)
                            : ""}
                          <span style={{ fontSize: "9px" }}>
                            {" "}
                            {/* {item?.argoworkflowstatus === "Active" &&
                          item?.nextrunon
                            ? timeZone?.[0]?.shortValue
                            : ""}{" "} */}
                            {item?.argoworkflowstatus === "Active" &&
                            item?.nextrunon
                              ? commonservices.convertDateToLocal(
                                  item?.nextrunon
                                )
                              : ""}{" "}
                          </span>
                        </td>
                        <td className="text-center">
                          <div className="d-flex">
                            <div className="mt-1 me-1">
                              {commonservices.getStatus(
                                item?.argoworkflowstatus
                              )}
                            </div>
                            <span className="mt-1">
                              {commonservices.getWithoutDotStatus(
                                item?.laststatus
                              )}
                            </span>
                          </div>
                          {/* <div>
                            {commonservices.getStatus(item?.laststatus)}
                          </div> */}
                        </td>
                        <td className="text-end">
                          <div
                            className="workflow-assignto contect-assignto "
                            style={{ marginLeft: "15px" }}
                          >
                            {displayedContacts?.map((contact, index) => (
                              <img
                                title={contact?.contactname}
                                key={index}
                                src={contact?.profilepicurl || profileicon}
                                alt={contact?.contactname}
                                className="profile-picture cursor-pointer"
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = profileicon;
                                }}
                              />
                            ))}
                            {remainingCount > 0 && (
                              <span className="workflow-assignto-remaining-images">
                                +{remainingCount}
                              </span>
                            )}
                            {/* {getContactListByWorkflow(item?.workflowid)}
                            <img src={collobers} alt="collobers" />
                            <img src={colloberstwo} alt="colloberstwo" />
                            <img src={collobers} alt="collobers" />
                            <img src={colloberstwo} alt="colloberstwo" />
                            <span className="workflow-assignto-remaining-images">
                              +5
                            </span> */}
                          </div>
                        </td>
                        {/* <td className="sticky-actions">
                          <div className="all-actions">
                            {item?.canedit && (
                              <>
                                <span
                                  onClick={() => {
                                    let data = commonservices.bodyEncryption(
                                      `${item?.workflowid}?v=0&r=dc`
                                    );
                                    navigate(`/flow-new/${data}`, {
                                      state: {
                                        isViewMode: false,
                                        flowRoleRights: item,
                                      },
                                    });
                                  }}
                                >
                                  <img
                                    src={editpencilIcon}
                                    alt="editAction"
                                    title="Edit"
                                  />
                                </span>
                              </>
                            )}
                            {item?.candelete && (
                              <img
                                src={deleteaction}
                                alt="deleteAction"
                                title="Delete"
                                onClick={() => {
                                  setModalShow(true);
                                  setDeletePayload({
                                    workflowid: item?.workflowid,
                                    status: "Delete",
                                  });
                                }}
                              />
                            )}
                          </div>
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={100}>
                      {" "}
                      <Nodata />
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </Table>
        {modalShow && (
          <DeleteModal
            payload={DeletePayload}
            url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
            show={modalShow}
            bindlist={getWorkFlowList}
            onHide={(e) => setModalShow(false)}
          />
        )}
      </div>
    </div>
  );
};

export default WorkflowManagementModel;
